import { atom } from 'jotai'
import type { TAddressHistory } from './TAddressHistory'
import type { TSelectedAddressHistory } from './TSelectedAddressHistory'

export const addressHistoryState = atom<TAddressHistory>({
    login_id: '',
    ushopCountryCode: '',
    log_id: null,
    duration: '',
    mainAddress: {
        shipToAddress: {
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            country: ''
        },
        shipToName: {
            firstName: '',
            lastName: '',
            fullName: '',
            'fullName@ja': ''
        },
        ushopShipToName: '',
        displayAddress: '',
        displayType: ''
    },
    totalItems: 0,
    items: [],
    invalidAddresses: []
})

export const selectedAddressHistoryState = atom<TSelectedAddressHistory>({
    address_id: 'main',
    addressHref: '',
    address: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: ''
    },
    shipToName: {
        firstName: '',
        lastName: '',
        fullName: '',
        'fullName@ja': ''
    },
    displayAddress: ''
})
